<template>
  <div class="gms" id="Games">
    <p class="title" name="Games">Games</p>
    <div class="main">
      <h4 class="sub-title">Some of our top featured games:</h4>
      <el-row>
        <el-col v-for="(item, index) in Array.from(new Array(12).keys())" :span="4" :xs="24" class="gms-img" :key="index">
          <a :href="item.url">
            <img height="100%" :src="require(`@images/gms_${index + 1}.png`)" />
          </a>
        </el-col>
      </el-row>
      <div class="gms-sp">
        <h4 class="sub-title">Want to see your game top the APP store chart?</h4>
        <el-button @click="handleClickJump" type="primary">&nbsp;&nbsp;&nbsp;Publish your games with us now >></el-button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Games",
  methods: {
    handleClickJump() {
      this.$router.push('/contact');
    }
  }
};
</script>
<style lang="scss" scoped>
.gms {
  background: #ffffff;
  position: relative;
  box-shadow: $section-box-shadow;
  .main {
    padding: 0 px2rem(20);
    margin-bottom: px2rem(50);
    .gms-sub-title {
      margin-top: px2rem(40);
    }
    .el-row {
      margin: 0 auto;
      margin-top: px2rem(0);
      max-width: px2rem(1000);
      .gms-img {
        margin: 12px auto;
        img {
          width: 85%;
          object-fit: contain;
        }
      }
    }
    .gms-sp {
      .sub-title {
        margin-top: px2rem(60);
      }
      .el-button {
        border-radius: px2rem(10);
        font-size: px2rem(14);
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        padding: px2rem(10) px2rem(20);
        i {
          font-size: px2rem(17);
        }
      }
    }
  }
}
</style>